import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone,FiMessageCircle,FiArrowDown,FiCheck}=FiIcons;

function Hero() {
  return (
    <section className="hero-section" id="home">
      <div className="hero-glow glow-a" />
      <div className="hero-glow glow-b" />
      <div className="hero-grid page-width">
        <motion.div className="hero-copy" initial={{opacity: 0,y: 24}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6}}>
          <span className="eyebrow"><span className="eyebrow-dot" /> Goulburn &amp; Rockdale, NSW</span>
          <h1>Start Your Journey Today! <span>Learn Fast &amp; Feel Confident</span> on the Road.</h1>
          <p className="hero-description">Calm, supportive automatic driving instruction across NSW, Australia. Get confident behind the wheel with expert lessons tailored to your stage.</p>
          <div className="price-pill"><span>Just</span><strong>$75</strong><span>Per Hour</span></div>
          <div className="hero-actions">
            <a className="button button-primary" href="tel:0433037815"><SafeIcon icon={FiPhone} /> Call Milan: 0433 037 815</a>
            <a className="button button-secondary" href="https://wa.me/61433037815"><SafeIcon icon={FiMessageCircle} /> Text / WhatsApp to Book</a>
          </div>
          <div className="hero-trust"><SafeIcon icon={FiCheck} /> New and test-ready students welcome</div>
          <a className="scroll-link" href="#lessons">Explore <SafeIcon icon={FiArrowDown} /></a>
        </motion.div>
        <motion.div className="hero-visual" initial={{opacity: 0,scale: 0.9}} animate={{opacity: 1,scale: 1}} transition={{duration: 0.8,delay: 0.1}}>
          <div className="orbit orbit-1" />
          <div className="orbit orbit-2" />
          <svg className="wheel" viewBox="0 0 200 200" aria-hidden="true">
            <circle cx="100" cy="100" r="82" fill="none" stroke="#F5B700" strokeWidth="14" />
            <circle cx="100" cy="100" r="16" fill="#F5B700" />
            <path d="M22 92h50l28 22 28-22h50M100 116v70" fill="none" stroke="#fff" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="l-plate">L</div>
          <div className="float-chip chip-1">Automatic</div>
          <div className="float-chip chip-2">Dual-control</div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;